// extracted by mini-css-extract-plugin
export default {"tile":"OutcomeTile_tile__LME3Y","p":"OutcomeTile_p__a-WYn"};